import { CircleCheck, Menu, UserRound } from "lucide-react";
import * as DropdownMenu from "radix-ui/dropdown-menu";
import { NavLink } from "react-router";

import { IconButton } from "../ui/Controls";

export function TopBar({
  onLogout,
  onMenu,
  title,
}: {
  readonly onLogout: () => void;
  readonly onMenu: () => void;
  readonly title: string;
}) {
  return (
    <header className="topbar">
      <div className="cluster">
        <IconButton
          className="topbar__menu"
          icon={<Menu aria-hidden="true" size={24} strokeWidth={1.75} />}
          label="Gezinme menüsünü aç"
          onClick={onMenu}
        />
        <strong>{title}</strong>
      </div>
      <div className="cluster">
        <span className="status-badge status-badge--success">
          <CircleCheck aria-hidden="true" size={16} strokeWidth={1.75} />
          <span>Etkin işlem yok</span>
        </span>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <IconButton
              icon={<UserRound aria-hidden="true" size={20} strokeWidth={1.75} />}
              label="Hesap menüsünü aç"
            />
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              align="end"
              className="card floating-card menu-content"
              sideOffset={8}
            >
              <DropdownMenu.Item asChild>
                <NavLink className="button button--quiet" to="/ayarlar/guvenlik">
                  Hesap güvenliği
                </NavLink>
              </DropdownMenu.Item>
              <DropdownMenu.Item asChild>
                <button className="button button--quiet" onClick={onLogout} type="button">
                  Çıkış yap
                </button>
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </div>
    </header>
  );
}
